import { orderBy } from 'lodash';
import {
  LightWeightObjectChangeTracker,
  SetOptions
} from '@schoolbelle/common/object-change-tracker';
import { TableHandler } from './table';
import { Cell } from './cell';

export class Row extends LightWeightObjectChangeTracker {
  get id(): string {
    return this.get('id');
  }
  get priority(): number {
    return this.get('priority');
  }
  set priority(v: number) {
    this.setPriority(v);
  }
  get text(): string {
    return this.get('text');
  }
  set text(v: string) {
    this.set('text', v);
  }
  get cells() {
    return orderBy(
      this.table.cells.filter(c => c.rowId === this.id),
      (cell: Cell) => {
        let col = this.table.columns.find(col => col.id === cell.colId);
        return col ? col.priority : undefined;
      }
    );
  }
  constructor(private table: TableHandler, id: string) {
    super(table, ['rows', id]);
    this.set('id', id, { push: 'none' });
  }
  setPriority(
    v_n: number,
    v_o: number = this.priority,
    siblings = this.table.rows,
    options?: SetOptions
  ) {
    // 0. validation
    if (v_o === v_n) return;

    // 1. correct value
    if (v_n !== Math.floor(v_n)) v_n = Math.floor(v_n); // must be integer.
    if (v_n < 0) v_n = 0; // cannot be negativ_ne.
    if (v_n > siblings.length - 1) v_n = siblings.length - 1; // can't skip over unused numbers
    if (typeof v_o === 'undefined') v_o = 1000;
    if (v_o === v_n) return;

    siblings.forEach(item => {
      if (v_o < v_n) {
        if (v_o < item.priority && item.priority <= v_n) {
          item.set(['priority'], item.priority - 1, options);
        }
      } else {
        if (v_n <= item.priority && item.priority < v_o)
          item.set(['priority'], item.priority + 1, options);
      }
    });
    this.set(['priority'], v_n, options);
  }
}
